import { PendingApprovals } from './PendingApprovals';

export default PendingApprovals;
